import { identityApiRef, useApi } from "@backstage/core-plugin-api";
import { catalogApiRef } from "@backstage/plugin-catalog-react";
import { useAsync } from "react-use";

// Hook to get current logged in user entity
export const useUserEntity = () => {
  const identityApi = useApi(identityApiRef);
  const catalogApi = useApi(catalogApiRef);
  
  const userIdentityAsync = useAsync(async () => {
    const identity = await identityApi.getBackstageIdentity();
    const entity = await catalogApi.getEntityByRef(identity?.userEntityRef);
    return entity;
  }, []);

  return userIdentityAsync;
};
